import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-coal py-12 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-78" data-mp="4vs0dxwxedqv">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-79" data-mp="9sry9ljmga6w">
        <Medallion icon={ShieldCheckIcon} data-id="element-80" data-mp="etz61klrl9dk" />

        <p className="eyebrow mt-6 text-gold" data-id="element-81" data-mp="eur20wj9x94d">Garantía de 7 días</p>
        <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-display text-[1.9rem] font-bold leading-[1.12] text-ivory sm:text-4xl" data-id="element-82" data-mp="jrhgjfffjwno">
          100% protegido
        </h2>

        <p className="mx-auto mt-6 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-83" data-mp="skcedo2kiq3f">
          Accedé al sistema completo y verificá que recibiste los 6 volúmenes y
          los 5 bonos detallados en esta página.
        </p>
        <p className="mx-auto mt-4 max-w-readable font-sans text-base leading-relaxed text-stone" data-id="element-84" data-mp="12kv3ax8zows7">
          Si algún archivo está incompleto, presenta problemas de acceso o el
          contenido entregado no corresponde con la descripción de esta oferta,
          escribinos dentro de los 7 días. Lo revisaremos y, si no podemos
          solucionarlo, te devolveremos el{' '}
          <span className="font-medium text-ivory" data-id="element-85" data-mp="1vuismnnss56o">100% de tu compra</span>.
        </p>
      </div>
    </section>;
}